import { z } from 'zod';

import { OTHER_TEXT_MAX_LENGTH } from './constants';

export const otherTextSchema = z
  .string()
  .max(OTHER_TEXT_MAX_LENGTH, `Max ${OTHER_TEXT_MAX_LENGTH} characters.`)
  .refine((value) => value.trim().length > 0, 'Field is required.');

export const isValidOtherText = (value: string): boolean =>
  otherTextSchema.safeParse(value).success;
